import { Type } from "class-transformer";
import { DossierDto } from "@/core/features/dossiers/dtos/dossier.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class PublicViewDto extends BaseEntityDto {
  @Type(() => DossierDto)
  dossier: DossierDto;
  dossierId: string;
}
